<template>
  <div class="login">
    <div class="login--box">
      <h1>Compliance</h1>
      <img
        @click="signIn"
        src="https://cdn.fbhl.com/auth-buttons/ms-sign-in-dark.png"
        alt="sign in with microsoft"
        class="pointer"
      />
    </div>
    <div class="login--modal" v-if="getLoggingIn">
      <div class="tile login--tile">
        <h2>Logging In</h2>
        <div class="flex__center">
          <font-awesome-icon icon="spinner" size="5x" class="loading--img" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from "../../../firebase/auth";
import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getLoggingIn"])
  },
  methods: {
    signIn() {
      auth.signIn(auth.provider);
    }
  }
};
</script>